import styled from "styled-components";

export const SectionHeader = styled.h4`
  display: block;
  margin: 0;
  background-color: var(--indigo7);
  font-weight: var(--global-font-weight-bold);
`;
